import CasRouterTabs from 'src/compass/shared/components/CasTabsView/CasRouterTabs';

import ReviewTab from './ReviewTab';
import PendingTab from './PendingTab';
import SendInitialTab from './SendInitialTab';

export const TabListTodoFwdContracts = {
  noDefault: true,
  tabs: [
    { label: 'Send Initial', children: <SendInitialTab /> },
    { label: 'Pending', children: <PendingTab /> },
    { label: 'Review', children: <ReviewTab /> }
  ],
};

export default function FwdContractsTab() {
  return (
    <CasRouterTabs
      asButtons
      baseUrl="/endorsements/claimtracking/todo/fwdContracts"
      tabList={TabListTodoFwdContracts.tabs}
    />
  );
}
